export const all = {
    label: "All",
    value: "all",
};
export const missingPhoto = {
    label: "Missing Photo",
    value: "missing_photo",
};
export const missingSomeQA = {
    label: "Missing Some Q+A",
    value: "missing_some_qa",
};
export const missingAllQA = {
    label: "Missing All Q+A",
    value: "missing_all_qa",
};

export const complete = {
    label: "Complete",
    value: "complete",
};
